<div class="h-full w-full flex flex-col justify-start items-center bg-[#f2f4f5]">
    <div
        class="flex flex-col items-center justify-center bg-white flex-1 min-[600px]:min-w-[600px] min-[600px]:max-w-[600px] min-[600px]:w-auto w-full !py-5 !px-4"
        *ngIf="invalidUser; else showAvailability">
        <div class="font-avenir font-medium text-base text-center text-[#62647e]">
            Hmm...this page is no longer available.<br />
            Most likely, this person has deactivated their profile.
        </div>
    </div>

    <ng-template #showAvailability>
        <div
            class="bg-white min-[600px]:min-w-[600px] min-[600px]:max-w-[600px] min-[600px]:w-auto w-full !pb-5 !px-0 min-[600px]:rounded-lg rounded-none">
            <fm-availability-list-header>
                <a
                    [routerLink]="'/user/' + memberProfile.profileUrl"
                    class="overflow-hidden no-underline">
                    <div class="flex flex-row items-center justify-start">
                        <app-profile-image
                            class="w-12 h-12"
                            [snoozed]="memberProfile.snoozeStatus"
                            [saved]="memberProfile.saved"
                            [profileImage]="memberProfile.photoUrl"
                            [snoozeTooltip]="memberProfile.snoozeExpiresAt"
                            size="medium">
                        </app-profile-image>

                        <div
                            class="text-bluegrey font-avenir font-semibold text-20-27 !ml-4 whitespace-nowrap text-ellipsis overflow-hidden"
                            >{{ memberProfile.firstName }}</div
                        >
                    </div>
                </a>
                <button
                    class="text-blurple text-sm border-2 border-solid border-[#DADAED] shadow-fm rounded-[5px] w-[34px] h-[34px] hover:bg-[#f2f3fe]"
                    (click)="reloadSelect()">
                    <fa-icon [icon]="faRefresh"></fa-icon>
                </button>
            </fm-availability-list-header>

            <fm-availability-list-controls
                (click)="dontPropagate($event)"
                (durationFilterSelected)="durationFilterSelected($event)"
                (quietModeChanged)="onQuietModeChanged($event)" />

            <div
                class="w-full flex flex-col items-center justify-start !py-0 !px-4 min-[600px]:h-[calc(100vh_-_327px)] h-[calc(100vh_-_317px)]">
                <ng-container [ngSwitch]="listContentState">
                    <ng-container *ngSwitchCase="'loading'">
                        <app-loading-indicator style="margin-top: 125px"></app-loading-indicator>
                    </ng-container>

                    <ng-container *ngSwitchCase="'emptyList'">
                        <div
                            class="font-avenir font-medium text-center text-[#62647e] text-base"
                            style="margin-top: 125px"
                            >No sessions available at the moment!</div
                        >
                    </ng-container>

                    <ng-container *ngSwitchCase="'validList'">
                        <!-- <perfect-scrollbar> -->
                        <ng-scrollbar class="w-full flex flex-col items-center justify-start">
                            <div
                                class="flex flex-col items-center justify-start w-full !pt-6 relative">
                                <div
                                    class="min-w-72 w-72 !mb-10"
                                    *ngFor="let day of filteredSessionList">
                                    <div
                                        class="font-semibold text-[15px] text-center text-bluegrey font-avenir !pb-6"
                                        >{{ day.dateLabel }}</div
                                    >

                                    <div
                                        class="flex flex-col !mb-5 last:!mb-0 w-full"
                                        *ngFor="let session of day.sessions">
                                        <div
                                            class="w-full flex flex-row items-center justify-start">
                                            <div
                                                class="text-12-16 font-avenir font-semibold text-[#A9A9A9]"
                                                >{{ session.sessionDurationLabel }}</div
                                            >
                                            <div
                                                class="flex flex-row justify-center self-stretch !ml-2 !mr-2.5 min-w-[2px] w-[2px] overflow-hidden bg-[#DADAED] rounded-[1px]">
                                            </div>
                                            <fm-availability-list-item
                                                class="w-[210px]"
                                                [externalId]="session.externalId"
                                                [sessionTime]="session.sessionTime"
                                                [sessionDuration]="session.sessionDuration"
                                                [sessionState]="session.sessionState"
                                                [sessionActivityType]="session.activityType"
                                                [durationLabel]="session.sessionDurationLabel"
                                                [sessionTimeLabel]="session.timeLabel"
                                                [booked]="session.confirmed"
                                                [selected]="session.sessionTime == selectedSession"
                                                [disable]="disableBookSessions"
                                                [userId]="session.partnerUserId"
                                                [displayName]="session.partnerDisplayName"
                                                [saved]="session.saved"
                                                [bookingComplete]="session.actionComplete"
                                                [partnerQuietMode]="
                                                    session.partnerPreferences.quietMode.value
                                                "
                                                [useTimeLabel]="true"
                                                [viewingSelf]="viewingSelf"
                                                (onCancelSession)="cancelSession($event)"
                                                (onBookSession)="bookSession($event)"
                                                (onSelectSession)="
                                                    selectSession($event)
                                                "></fm-availability-list-item> </div
                                    ></div>
                                </div>
                            </div>
                            <!-- </perfect-scrollbar> -->
                        </ng-scrollbar>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </ng-template>
</div>
